import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import FlipMove from 'react-flip-move'
import ReactHtmlParser from 'react-html-parser'
import cn from 'classnames'
import { fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchCategoriesIfNeeded, setCatFilter } from '../actions'
import { DEFAULT_PAGE } from '../reducers/pages'
import { DEFAULT_CUSTOM_POST } from '../reducers/customposts'
import { DEFAULT_CATEGORIES } from '../reducers/categories'
import { DEFAULT_CAT_FILTER } from '../reducers/filtercats'
import { Main, Left, Right } from '../components/Content'
import { Box } from '../components/Blocks'


class Trainingen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filtersOpen: false,
        }
        this.toggleFilters = this.toggleFilters.bind(this)
    }
    componentWillMount() {
        const { fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchCategoriesIfNeeded } = this.props
        fetchPageIfNeeded('trainingen')
        fetchCustomPostsIfNeeded('trainingen')
        fetchCategoriesIfNeeded()
    }
    toggleFilters() {
        this.setState({
            filtersOpen: !this.state.filtersOpen
        })
    }
    render() {
        const { page, posts, categories, setCatFilter, selectedCats } = this.props
        const filterAnimClass = cn('filter-anim', {open: this.state.filtersOpen})
        return (
            <Main>
                <Left>
                    <h1>{ReactHtmlParser(page.title.rendered)}</h1>
                    <TrainingList posts={posts} selectedCats={selectedCats} />
                </Left>
                <Right>
                    <div className="hide-for-medium filtertoggle" onClick={this.toggleFilters}><div className={filterAnimClass}><span/></div></div>
                    <TrainingFilters open={this.state.filtersOpen} categories={categories} setFilter={setCatFilter} selectedCats={selectedCats} />
                    <Box color="primary filter" text={page.content.rendered} />
                </Right>
            </Main>
        )
    }
}

const TrainingList = (props) =>
    <FlipMove typeName="ul" className="training-list" enterAnimation="fade" leaveAnimation="fade">
    {props.posts.map( (post, i) => 
        ( props.selectedCats.length === 0 || props.selectedCats.filter(element => post.categories.includes(element)).length > 0 ) && 
            <li key={post.slug}><TrainingListItem post={post} /></li>
    )}
    </FlipMove>

const TrainingListItem = (props) =>
    <Link to={`/trainingen/${props.post.slug}`}>
        <div className="arrow"><i className="material-icons">keyboard_arrow_right</i></div>
        <div className="content">
            <h5 className="title">{ReactHtmlParser(props.post.title.rendered)}</h5>
            <span className="short">{ReactHtmlParser(props.post.cmb2._training_intro_metabox._training_intro_excerpt)}</span>
        </div>
    </Link>

const TrainingFilters = (props) => {
    const filterClass = cn('filters', {open: props.open})
    return (
        <div className={filterClass}>
            <h4>Vind de training die bij je past</h4>
            {props.categories.map( (cat, i) => 
                cat.slug !== 'none' && <TrainingToggle key={i} category={cat} setFilter={props.setFilter} selected={props.selectedCats.includes(cat.id)} />
            )}
        </div>
    )

}

const TrainingToggle = (props) =>
    <div className="toggle" onClick={props.setFilter.bind(this, props.category.id)}>
        <div className="switch tiny">
          <input className="switch-input" id={props.category.slug} type="checkbox" name={props.category.slug} checked={props.selected} readOnly/>
          <label className="switch-paddle" htmlFor={props.category.slug} />
        </div>
        {ReactHtmlParser(props.category.name)}
    </div>

function mapStateToProps(state, ownProps) {
    const page = state.pages['trainingen'] || state.pages[DEFAULT_PAGE]
    const posts = state.customposts['trainingen'] || state.customposts[DEFAULT_CUSTOM_POST]
    const categories = state.categories.categories || state.categories[DEFAULT_CATEGORIES]
    const selectedCats = state.filtercats.catfilter || state.filtercats[DEFAULT_CAT_FILTER]
    return {
        page: page,
        posts: posts,
        categories: categories,
        selectedCats: selectedCats,
    }
}

export default connect(mapStateToProps,{ fetchPageIfNeeded, fetchCustomPostsIfNeeded, fetchCategoriesIfNeeded, setCatFilter })(Trainingen)


// WEBPACK FOOTER //
// ./src/pages/Trainingen.js